import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import {store} from "./store";

const checkForUpdates = async () => {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' });
    const { version } = await res.json();
    const stored = localStorage.getItem('appVersion');
    if (stored && stored !== String(version)) {
      localStorage.setItem('appVersion', String(version));
      window.location.reload();
      return;
    }
    localStorage.setItem('appVersion', String(version));
  } catch (_) {}
};

checkForUpdates();

window.addEventListener('pageshow', (event) => {
  if (event.persisted) checkForUpdates();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  //   <Provider store={store}>
  //     <BrowserRouter basename="/">
  //       <App />
  //     </BrowserRouter>
  //   </Provider>
  // </React.StrictMode>
  <Provider store={store}>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
